/*  eslint-disable */

import { callMeNowResponse } from '../actions/callMeNow';
import config from '../config/config';
import REST_API_NAMES from '../config/restApiNames';
import moment from 'moment-timezone';
import { callApi } from '../util/ApiUtil';
import { UAParser } from 'ua-parser-js';
import SafeConsole from '../util/ConsoleUtils';

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_FORMAT_WITH_TZ = 'YYYY-MM-DD HH:mm z';

let ua = new UAParser(window.navigator.userAgent),
  os = ua.getOS(),
  device = ua.getDevice(),
  browser = ua.getBrowser();

var deviceInfo = '';
if (device.model) {
  deviceInfo += device.vendor + ' ' + device.model + ' - ';
}
deviceInfo += os.name + ' ' + os.version;
// var deviceOsType = os.name;
var repDeviceInfo = deviceInfo;
var repBrowserInfo = browser.name + ' ' + browser.version;

const VHT_CANCEL_INTERACTION_SOAP_TEMPLATE =
  '<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"> <soap:Body><RemoveInteraction xmlns="http://www.virtualhold.com/Toolkit/Platform-v5"><data> <Tenant>Asurion</Tenant> <InteractionId>#vhtId#</InteractionId><Reason>Admin Canceled</Reason><Options><ClientId>string</ClientId></Options></data></RemoveInteraction></soap:Body></soap:Envelope>';

var BUSINESS_HOUR = {
  ADT: {
    weekday: { start: 9, for: 15 },
    weekend: { start: 11, for: 11 },
  },
  AST: {
    weekday: { start: 9, for: 15 },
    weekend: { start: 11, for: 11 },
  },
  EDT: {
    weekday: { start: 8, for: 15 },
    weekend: { start: 10, for: 11 },
  },
  EST: {
    weekday: { start: 8, for: 15 },
    weekend: { start: 10, for: 11 },
  },
  CDT: {
    weekday: { start: 7, for: 15 },
    weekend: { start: 9, for: 11 },
  },
  CST: {
    weekday: { start: 7, for: 15 },
    weekend: { start: 9, for: 11 },
  },
  MDT: {
    weekday: { start: 6, for: 15 },
    weekend: { start: 8, for: 11 },
  },
  MST: {
    weekday: { start: 6, for: 15 },
    weekend: { start: 8, for: 11 },
  },
  PDT: {
    weekday: { start: 5, for: 15 },
    weekend: { start: 7, for: 11 },
  },
  PST: {
    weekday: { start: 5, for: 15 },
    weekend: { start: 7, for: 11 },
  },
  AKDT: {
    weekday: { start: 4, for: 15 },
    weekend: { start: 6, for: 11 },
  },
  AKST: {
    weekday: { start: 4, for: 15 },
    weekend: { start: 6, for: 11 },
  },
  HST: {
    weekday: { start: 3, for: 15 },
    weekend: { start: 5, for: 11 },
  },
};

const VHT_NEXT_AVAILABLE_TIME_SOAP_TEMPLATE =
  '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' +
  'xmlns:xsd="http://www.w3.org/2001/XMLSchema" ' +
  'xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"> ' +
  '<soap:Body> ' +
  '<GetNextAvailableAppointmentTimes xmlns="http://www.virtualhold.com/Toolkit/Platform-v5"> ' +
  '<data> ' +
  '<Tenant>Asurion</Tenant> ' +
  '<Segment>#vhtSegmentId#</Segment> ' +
  '<Options> ' +
  '<NumberOfAppointments>4</NumberOfAppointments> ' +
  '<AppointmentTime>#appointmentTime#</AppointmentTime> ' +
  '    </Options> ' +
  '    </data> ' +
  '    </GetNextAvailableAppointmentTimes> ' +
  '    </soap:Body> ' +
  '</soap:Envelope>';

var VHT_EXTRA_DATA_ITEM = '';

var VHT_ADD_INTERACTION_SOAP_TEMPLATE =
  '<soapenv:Envelope ' +
  'xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" ' +
  'xmlns:plat="http://www.virtualhold.com/Toolkit/Platform-v5"> ' +
  '<soapenv:Header/> ' +
  '<soapenv:Body> ' +
  '<plat:AddInteraction> ' +
  '<plat:data> ' +
  '<plat:Tenant>Asurion</plat:Tenant> ' +
  '<plat:Segment>#vhtSegmentId#</plat:Segment> ' +
  '<plat:Contact>#customerCallbackNumber#</plat:Contact> ' +
  '<plat:Options> ' +
  '<plat:AppointmentTime>#appointmentTime#</plat:AppointmentTime> ' +
  '<plat:UserData> ' +
  '<plat:UserDataItem> ' +
  '<plat:Name>OLDCALLID</plat:Name> ' +
  '<plat:Value>#callId#</plat:Value> ' +
  '<plat:DataType>String</plat:DataType> ' +
  '</plat:UserDataItem> ' +
  VHT_EXTRA_DATA_ITEM +
  ' ' +
  '</plat:UserData> ' +
  '</plat:Options> ' +
  '</plat:data> ' +
  '</plat:AddInteraction> ' +
  '</soapenv:Body> ' +
  '</soapenv:Envelope>';

export function getCurrentTimezone() {
  return moment.tz.guess();
  // return 'America/Los_Angeles';
}

export function getCurrentTimezoneId() {
  return moment.now().format('z');
}

export function getCurrentTimeInUTC() {
  return moment.utc();
  //return moment.utc().add(6, 'hours').add(15, 'minutes');
}

export function getCurrentTimeInMilliSeconds() {
  return moment.valueOf();
  //return moment.utc().add(6, 'hours').add(15, 'minutes');
}

export function getCurrentTimestampInCurrentTimezone() {
  return getCurrentTimeInUTC().tz(getCurrentTimezone()).unix;
}

export function getCurrentTimestampInUTC() {
  return getCurrentTimeInUTC().unix;
}

export function getCurrentTimeInUTCFormatted() {
  return getCurrentTimeInUTC().format();
}

export function getCurrentTimeInCurrentTimezoneFormatted(format = null) {
  if (format) {
    return moment.tz(getCurrentTimezone()).format(format);
  } else {
    return moment.tz(getCurrentTimezone()).format();
  }
}

export function getFormattedTime(time, timezone, format = null) {
  if (format) {
    return moment.tz(time, timezone).format(format);
  } else {
    return moment.tz(time, timezone).format();
  }
}

function shouldRetryForGetVHTSlots(resp) {
  var shouldRetry = false;
  var result = resp;
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(result, 'text/xml');
  var nodes = xmlDoc.getElementsByTagName('Code');
  var code = nodes && nodes.length > 0 ? nodes[0].childNodes[0].nodeValue : 'UNKNOWN';
  if (['107000', '107001'].indexOf(code) > -1) {
    shouldRetry = false;
  } else {
    shouldRetry = false;
  }
  return shouldRetry;
}

var callMeNowAPI = {
  getCallMeNowSlots: function getCallMeNowSlots(vhtsegment, storeCode, requestTimeInCurrentTimezone, dispatch) {
    var currentTimeInUTC = getCurrentTimeInUTC();
    if (requestTimeInCurrentTimezone) {
      currentTimeInUTC = moment.tz(requestTimeInCurrentTimezone, getCurrentTimezone()).utc();
    }

    SafeConsole.info('get current time:', getCurrentTimeInCurrentTimezoneFormatted(DATE_FORMAT_WITH_TZ));
    SafeConsole.info('current time in UTC format:', currentTimeInUTC.format());
    SafeConsole.info('vht segment:', vhtsegment);

    let sr = VHT_NEXT_AVAILABLE_TIME_SOAP_TEMPLATE.replace('#vhtSegmentId#', vhtsegment).replace(
      '#appointmentTime#',
      currentTimeInUTC.format()
    );
    SafeConsole.info('Payload for vht call', JSON.stringify({ body: sr, storeCode: storeCode }));
    callApi({
      method: 'POST',
      url: config.REST_URL(REST_API_NAMES.vhtGetNextAvailableAppointmentTime),
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      body: JSON.stringify({ body: sr, storeCode: 'null' }),
      shouldRetry: shouldRetryForGetVHTSlots,
      retries: 0,
    })
      .then((result) => {
        SafeConsole.info('result', result);
        var response = {};
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(result, 'text/xml');
        var nodes = xmlDoc.getElementsByTagName('Code');
        var code = nodes && nodes.length > 0 ? nodes[0].childNodes[0].nodeValue : 'UNKNOWN';
        var DT_FROM_VHT = []; // reset DT varirable
        var waitInMinutes = 1800;
        var earliestSlot = '';
        if (['107000', '107001'].indexOf(code) > -1) {
          var availableTimes = xmlDoc.getElementsByTagName('AppointmentTimes')[0].getElementsByTagName('string');
          if (availableTimes && availableTimes.length > 0) {
            for (var i = 0; i < availableTimes.length; i++) {
              var item = availableTimes[i],
                timestamp = item.childNodes[0].nodeValue;
              var slotTime = getFormattedTime(timestamp, getCurrentTimezone(), DATE_FORMAT);
              DT_FROM_VHT.push(slotTime);
              var waitTime = Math.round(
                moment.duration(moment.tz(timestamp, 'UTC').diff(currentTimeInUTC)).asMinutes()
              );
              SafeConsole.info('Time Diff in Minutes', waitTime);
              if (waitTime <= waitInMinutes) {
                waitInMinutes = waitTime;
                earliestSlot = slotTime;
              }
            }
          }
          response['vhtSlots'] = DT_FROM_VHT;
          response['currentTimezone'] = getCurrentTimezone();
          response['waitInMinutes'] = waitInMinutes;
          response['earliestSlot'] = earliestSlot;

          //var zoneId = dt.format('z');
          var zoneId = getCurrentTimeInCurrentTimezoneFormatted('z');
          SafeConsole.info('zoneId', zoneId);
          var withinBusinessHourRange = false;
          if (BUSINESS_HOUR[zoneId]) {
            var businessHour = BUSINESS_HOUR[zoneId].weekday;
            if (/(Sat|Sun)/.test(getCurrentTimeInCurrentTimezoneFormatted('ddd'))) {
              businessHour = BUSINESS_HOUR[zoneId].weekend;
            }
            SafeConsole.info(businessHour);
            var currentHour = parseInt(getCurrentTimeInCurrentTimezoneFormatted('hh'));
            SafeConsole.info('current hour', currentHour);
            if (currentHour >= businessHour.start && currentHour <= businessHour.start + businessHour.for) {
              withinBusinessHourRange = true;
            }
          }
          response['withinBusinessHourRange'] = withinBusinessHourRange;
          response['state'] = 'success';
          response['errorCode'] = 0;
          dispatch(callMeNowResponse(response));
        } else {
          SafeConsole.log('callMeNowResponse returned with error code = ', code);
          var response = {};
          response['state'] = 'failure';
          response['errorCode'] = code;
          dispatch(callMeNowResponse(response));
        }
      })
      .catch((error) => {
        SafeConsole.log('callMeNowResponse returned with error = ', error);
        var response = {};
        response['state'] = 'failure';
        response['errorCode'] = 99;
        dispatch(callMeNowResponse(response));
      });
  },
  createAppointmentInVHT: function createAppointmentInVHT(payload, requestTimeInCurrentTimezone) {
    var currentTimeInUTC = getCurrentTimeInUTC();
    if (requestTimeInCurrentTimezone) {
      currentTimeInUTC = moment.tz(requestTimeInCurrentTimezone, getCurrentTimezone()).utc();
    }
    let sr = VHT_ADD_INTERACTION_SOAP_TEMPLATE.replace('#customerCallbackNumber#', payload.formattedCallbackNumber)
      .replace('#callId#', payload.callId)
      .replace('#vhtSegmentId#', payload.vhtSegment)
      .replace('#appointmentTime#', currentTimeInUTC.format());
    SafeConsole.info('Payload for appointment booking vht call', JSON.stringify({ body: sr }));
    return callApi({
      method: 'POST',
      url: config.REST_URL(REST_API_NAMES.vhtAddAppointment),
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      body: JSON.stringify({ body: sr }),
      //shouldRetry: shouldRetryForSendToVHT,
      //retries:0
    });
  },
  sendToCSDB: function sendToCSDB(data, requestTimeInCurrentTimezone) {
    var currentTimeInUTC = getCurrentTimeInUTC();
    if (requestTimeInCurrentTimezone) {
      currentTimeInUTC = moment.tz(requestTimeInCurrentTimezone, getCurrentTimezone()).utc();
    }
    return callApi({
      method: 'POST',
      url: config.REST_URL(REST_API_NAMES.csdb),
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      body: JSON.stringify({
        ChannelShareDataParameters: {
          MobileDeviceNumber: data.formattedCallbackNumber,
          CallId: data.callId,
          Channel: data.csdbChannel,
          ChannelShareDataElements: {
            ChannelShareDataElement: [
              { Name: 'callbackMdn', Value: data.formattedCallbackNumber },
              { Name: 'MDN', Value: data.formattedCallbackNumber },
              { Name: 'attDeviceSetup', Value: data.attDeviceSetup },
              { Name: 'oldDeviceModel', Value: data.customerOldDeviceModel },
              { Name: 'newDeviceModel', Value: data.customerNewDeviceModel },
              { Name: 'firstName', Value: data.customerFirstName },
              { Name: 'lastName', Value: data.customerLastName },
              { Name: 'attRepName', Value: data.customerFirstName + ',' + data.customerLastName },
              { Name: 'storeCity', Value: data.customerCity },
              { Name: 'description', Value: data.customerAppointmentDescription },
              { Name: 'newDeviceMDN', Value: data.formattedCallbackNumber },
              { Name: 'storeLocation', Value: data.storeLocation },
              { Name: 'ClientCode', Value: data.vhtClientcode },
              { Name: 'CTI_CLIENT', Value: data.CTI_CLIENT },
              { Name: 'LANGUAGE', Value: data.language },
              {
                Name: 'customerAppointmentDateTime',
                Value: currentTimeInUTC.format(),
              },
            ],
          },
        },
      }),
      retries: 0,
    });
  },
  sendToV1: function sendToV1(data, requestTimeInCurrentTimezone) {
    var currentTime = getCurrentTimeInMilliSeconds();
    if (requestTimeInCurrentTimezone) {
      currentTime = moment.tz(requestTimeInCurrentTimezone, DATE_FORMAT, getCurrentTimezone()).valueOf();
    }
    return callApi({
      method: 'POST',
      url: config.REST_URL(REST_API_NAMES.createAppointment),
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      body: JSON.stringify({
        agent_json: {
          storeName: data.storeName,
          agentAssignStatus: data.agentAssignStatus,
          assignedAgentName: data.assignedAgentName,
          customerAppointmentDateTime: currentTime, //1537202700000
          customerAppointmentDescription: data.customerAppointmentDescription,
          customerCallbackNumber: data.formattedCallbackNumber,
          customerFirstName: data.customerFirstName,
          customerLastName: data.customerLastName,
          customerNewDeviceModel: data.customerNewDeviceModel,
          customerOldDeviceModel: data.customerOldDeviceModel,
          customerSessionId: data.callId,
          endpointId: data.endpointId,
          repBrowserInfo: repBrowserInfo,
          repDeviceInfo: repDeviceInfo,
          storeLocation: data.storeLocation,
          subscriberMdn: data.formattedCallbackNumber,
          timezone: getCurrentTimezone(),
          universalId: data.universalId,
          captchaResponse: data.captchaResponse,
          messageId: data.messageId,
          channel: data.channel,
          applicationId: data.applicationId,
          megaUseCase: data.megaUseCase,
          vhtclientCode: data.vhtClientcode,
          vhtSegmentId: data.vhtSegment,
          sourceDomain: data.sourceDomain,
          appointmentType: data.appointmentType,
        },
      }),
      retries: 0,
    });
  },
  getAtlasId: function getAtlasId(callId, formattedCallbackNumber) {
    return callApi({
      method: 'POST',
      url: config.REST_URL(REST_API_NAMES.getAtlasId),
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      body: JSON.stringify({ subscriberMdn: formattedCallbackNumber, customerSessionId: callId }),
      retries: 0,
    });
  },
  sendId: function sendId(payload) {
    return callApi({
      method: 'PUT',
      url: config.REST_URL(REST_API_NAMES.sendV1IdAndVhtId),
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      body: JSON.stringify(payload),
      retries: 0,
    });
  },
  cancelAppointment: function cancelAppointment(vhtId) {
    let sr = VHT_CANCEL_INTERACTION_SOAP_TEMPLATE.replace('#vhtId#', vhtId);
    SafeConsole.info('cancel appointment called with vhtId', vhtId);

    /**
        return callApi({
            method:'POST',
            url: config.REST_URL(REST_API_NAMES.cancelAppointment),
            headers: {
                "Content-Type": 'text/xml',
               // Accept:'* /*'
            },
            body: sr,
            retries:0
            }
        );**/
    return callApi({
      method: 'POST',
      url: config.REST_URL(REST_API_NAMES.vhtAddAppointment), //add appointment call can also be used for cancellation..
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      body: JSON.stringify({ body: sr }),
    });
  },
};
export default callMeNowAPI;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/api/CallMeNow.js